export default "__VITE_ASSET__add82831__"